// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brandhub-icon path{fill:var(--icon-color,currentColor)}.brandhub-icon circle,.brandhub-icon path{transition:fill var(--icon-transition,.16s ease-out)}.brandhub-icon circle{fill:var(--icon-circle-color,#fff)}", ""]);
// Exports
module.exports = exports;
